import React from "react";
import Particles from "react-tsparticles";

function Particle() {

  return (
    <Particles
      id="tsparticles"
      params={{
        particles: {
          number: {
            value: 160,
            density: {
              enable: true,
              value_area: 1450,
            },
          },
          color: "#6441a5",
          line_linked: {
            enable: false,
            opacity: 0.10,
          },
          move: {
            direction: "right",
            speed: 0.05,
          },
          size: {
            value: 1.2,
          },
          opacity: {
            anim: {
              enable: true,
              speed: 2,
              opacity_min: 0.08,
            },
          },
        },
        interactivity: {
          events: {
            onclick: {
              enable: true,
              mode: "push",
            },
          },
          modes: {
            push: {
              particles_nb: 1,
            },
          },
        },
        retina_detect: true,
      }}
    />
  );
}

export default Particle;